module.exports = __webpack_public_path__ + "rosacea_2_after_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/dermatologie/rosacea_2_after_tn.jpg
// module id = 1447
// module chunks = 0